import { PageHead } from '../reporting/PageHead';
import { Panel } from '../dashboard/ui';

export function DeliveryCost() {
  return (
    <section className="report">
      <PageHead crumb="Cost / Delivery cost" title="Delivery cost" />
      <Panel title="Cost per delivery" subtitle="Delivery cost & charge analysis">
        <div className="empty-note">
          <strong>No cost data available in the source.</strong>
          <p className="muted">
            The cost and charge fields on <code>stop_reports</code> (<code>total_cost</code>,{' '}
            <code>total_charge</code>, <code>base_charge</code>, <code>fuel_levy</code>) are not
            populated for this team, and the invoice tables are empty. Once cost data is synced,
            this page will show cost per stop, cost trend, and cost by region & driver.
          </p>
        </div>
      </Panel>
    </section>
  );
}
